export const withoutValueAtIndex = (array, index: number) => {
  return [...array.slice(0, index), ...array.slice(index + 1)];
};
